import { Deserializable } from '../../protocols/deserializable';

/**
 * What a WebsocketActionRequestType_BulkDeleteAssets job answers with once it finishes. skipped* counts items that
 * were already gone - not an error, expected on a retry or a stale selection.
 */
export class BulkDeleteAssetsResponse implements Deserializable {
  public deletedAssetCount: number;
  public deletedFolderCount: number;
  public movedAssetCount: number;
  public movedFolderCount: number;
  public skippedAssetCount: number;
  public skippedFolderCount: number;

  public onDeserialize() {}

  summaryForLog(): string {
    return (
      `deleted ${this.deletedAssetCount ?? 0} media and ${this.deletedFolderCount ?? 0} folders, ` +
      `moved ${this.movedAssetCount ?? 0} media and ${this.movedFolderCount ?? 0} folders, ` +
      `skipped ${this.skippedAssetCount ?? 0} media and ${this.skippedFolderCount ?? 0} folders`
    );
  }
}
